import TemplateSplitRoute from '@/features/data/templates/components/TemplateSplitRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/data/templates')({
  component: TemplateSplitRoute,
});
